export default "__VITE_ASSET__CwcdVZcs__"